"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ensureNumber = function (n) {
    if (typeof n === "string") {
        var num = parseFloat(n.replace(/[\s,\$%€£¥A-Z]/gi, ''));
        return num;
    }
    else {
        return n;
    }
};
